<dx-box
    #vendorSearchBox
    height="100%"
    width="100%"
    direction="col"
    class="cc-search-grid-container"
    [elementAttr]="{ id: 'vendorSearchBox' + (!widgetId ? '' : widgetId) }"
>
    <dxi-item [ratio]="1">
        <cc-data-grid-features
            #gridFeatures
            [stateConfig]="{ storageKey: 'VENDORS_SEARCH_GRID', storeGroupings: true }"
            [gridFeatures]="{ allowGrouping: true }"
            [dataSource]="vendors"
        >
            <dx-data-grid width="100%" height="100%" [dataSource]="vendors">
                <dxo-search-panel [text]="searchText" [visible]="showSearchPanel"></dxo-search-panel>
                <dxi-column dataField="location" caption="Location" dataType="string"></dxi-column>
                <dxi-column
                    dataField="community"
                    caption="Community"
                    dataType="string"
                    cellTemplate="communityTemplate"
                    groupCellTemplate="groupCellTemplate"
                ></dxi-column>
                <dxi-column dataField="vendorName" caption="Vendor Name" dataType="string"></dxi-column>
                <dxi-column dataField="vendorType" caption="Vendor Type" dataType="string"></dxi-column>
                <dxi-column
                    dataField="isActive"
                    caption="Active"
                    dataType="boolean"
                    cellTemplate="isActiveTempalte"
                ></dxi-column>
                <dxi-column
                    dataField="approved"
                    caption="Approved"
                    dataType="boolean"
                    cellTemplate="isActiveTempalte"
                ></dxi-column>
                <dxi-column
                    dataField="w9FileInfo"
                    caption="W9"
                    dataType="string"
                    alignment="center"
                    cellTemplate="fileNameTemplate"
                ></dxi-column>
                <dxi-column
                    dataField="is1099Vendor"
                    caption="1099"
                    dataType="boolean"
                    cellTemplate="is1099VendorTempalte"
                ></dxi-column>
                <dxi-column dataField="contactName" caption="Contact Name" dataType="string"></dxi-column>
                <dxi-column dataField="email" caption="Email" [allowGrouping]="false" dataType="string"></dxi-column>
                <dxi-column dataField="phone" caption="Phone" [allowGrouping]="false" dataType="string"></dxi-column>
                <dxi-column dataField="fax" caption="Fax" [allowGrouping]="false" dataType="string"></dxi-column>
                <dxi-column
                    dataField="address"
                    caption="Address"
                    [allowGrouping]="false"
                    dataType="string"
                ></dxi-column>

                <div *dxTemplate="let cell of 'communityTemplate'">
                    <app-property-community-link
                        [communityId]="cell.data.communityId"
                        [displayText]="cell.value"
                    ></app-property-community-link>
                </div>

                <div *dxTemplate="let row of 'isActiveTempalte'" class="status-cell-template">
                    <i *ngIf="row.value" class="cc-green-icon cc-1-5x" [ngClass]="iconCheck" aria-hidden="true"></i>
                    <i *ngIf="!row.value" class="cc-red-icon cc-1-5x" [ngClass]="iconClose" aria-hidden="true"></i>
                </div>

                <div *dxTemplate="let row of 'is1099VendorTempalte'" class="status-cell-template">
                    <i *ngIf="row.value" class="cc-green-icon cc-1-5x" [ngClass]="iconCheck" aria-hidden="true"></i>
                </div>

                <div *dxTemplate="let row of 'fileNameTemplate'" class="status-cell-template">
                    <i
                        class="cc-1-5x icon-content cc-hyperlink icon-data-content"
                        [ngClass]="getFileIcon(row.data)"
                        (click)="downloadFile(row.data)"
                    ></i>
                </div>

                <div *dxTemplate="let groupdata of 'groupCellTemplate'">
                    <div class="community-group">
                        Community:&nbsp;
                        <app-property-community-link
                            [communityId]="getCommunityId(groupdata.data)"
                            [displayText]="groupdata.value"
                        ></app-property-community-link>
                    </div>
                </div>

                <dxo-summary>
                    <dxi-group-item column="email" summaryType="count" displayFormat="Count = {0}"></dxi-group-item>
                </dxo-summary>
            </dx-data-grid>
        </cc-data-grid-features>
    </dxi-item>
</dx-box>

<dx-load-panel
    [position]="{ of: !widgetId ? 'body' : '#vendorSearchBox' + widgetId }"
    *ngIf="loadingVisible"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="!widgetId"
    [shading]="!widgetId"
    [closeOnOutsideClick]="false"
></dx-load-panel>
